﻿$(function () {
    //console.log(sessionStorage.scrollTop);

    $('.facet-area').on('click', '.facet-group a', function (e) {
        e.preventDefault();

        var InModal = $(this).parents('.filter-menu').length > 0;
        //console.log($(this).data('attr'));
        //console.log($(this).data('val'));
        if ($(this).hasClass('facet-selected')) {
            $(this).removeClass('facet-selected');
            $(this).find('.fa').removeClass('fa-check-square-o').addClass('fa-square-o');
        } else {
            $(this).addClass('facet-selected');
            $(this).find('.fa').removeClass('fa-square-o').addClass('fa-check-square-o');
        }
        //console.log(GetSelectedFacets());
        //console.log();

        if (!InModal) {
            var ExtraFacetData = getURLExtraFacetBits();
            if (ExtraFacetData != null && ExtraFacetData != '') {
                window.location.assign($(this).attr('href') + '?f=' + ExtraFacetData);
            } else {
                window.location.assign($(this).attr('href'));
            }

            //window.location.hash = getURLExtraFacetBits();
        }
    });

    $('.apply-filters').on('click', function (e) {
        e.preventDefault();

        var ExtraFacetData = getURLExtraFacetBits();
        if (ExtraFacetData != null && ExtraFacetData != '') {
            window.location.assign($(this).attr('href') + '?f=' + ExtraFacetData);
        } else {
            window.location.assign($(this).attr('href'));
        }
    });

    //var posTemp = $('.section-product-listing-page').position();


    if ($('.facet-group').length > 0 && sessionStorage.scrollTop != "undefined") {
        //console.log(window.location.search);
        var url = window.location.search;
        //console.log(url);
        if (url != null && url != '' && url.match("f=").length > 0) {
            var pos = $('.section-product-listing-page').position();
            $(window).scrollTop(pos.top);
        }

    } else {
        //sessionStorage.scrollTop = 0;
    }

    var filterContentCache;
    $('.filter-list-btn').on('click', function (e) {
        var filterContent = $('.section-product-listing-page .section-listing').children().detach();
        filterContentCache = filterContent.clone(true);
        $('.filter-menu .section-listing').empty().append(filterContent);
    });

    $('.close-filter-menu').on('click', function (e) {
        setTimeout(function () {
            $('.filter-menu .section-listing').empty();
            $('.section-product-listing-page .section-listing').empty().append(filterContentCache);
        }, 250);
    });
});

$(window).scroll(function () {
    if ($('.facet-group').length > 0) {
        sessionStorage.scrollTop = $(this).scrollTop();
    }
});

function GetSelectedFacets() {
    var t = [];
    $('.facet-group a.facet-selected').each(function (index) {
        //console.log($(this).data('val'));
        var f = {
            attribute: $(this).data('attr'), facetvalue: encodeURIComponent($(this).data('val').toString().toLowerCase())
        };
        t.push(f);
    });

    return t;
}

function getURLExtraFacetBits() {
    var existingFacets = GetSelectedFacets();

    var extraFacetURLBits = '';
    if (existingFacets.length > 0) {
        $.each(existingFacets, function (index, value) {
            if (index > 0) {
                extraFacetURLBits += '|';
            }
            extraFacetURLBits += value.attribute + ':' + value.facetvalue;
        });
    }

    return extraFacetURLBits;
}
